import React from "react";
class LabelFactory {
  create(label, required) {
    if (!label) {
      return '';
    }
    return !required ? label : /*#__PURE__*/React.createElement(React.Fragment, null, label, " ", /*#__PURE__*/React.createElement("span", {
      className: 'required-indicator'
    }, "*"));
  }
}
const labelFactory = new LabelFactory();
export default labelFactory;